import { cx } from '@linaria/core';
import { useMemo } from 'react';
import { breakpoints } from '@ui/css';
import { Table, Row, SortableColumnHeading, ColumnHeading } from '@ui/kit';
import { useMatchBreakpoint } from '@utils/react';
import { EmptyMessage } from '../atoms/empty-message.js';
import { useAppliedTimespan } from '../hook.applied-timespan.js';
import { tableCls } from '../shared.table.style.js';
import { useComponentEntrySelector } from '../state.js';
import { TableItem } from './table.item.js';
import { rowSizingCls, thead } from './table.root.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useSortState, sortComponentEntries } from '../utils/sort.js';
import { generateTableKey } from '../utils/table-key.js';

function StudentEntriesTable(props) {
  const filters = useComponentEntrySelector(state => state);
  const [sort, onSort] = useSortState();
  const appliedTimespan = useAppliedTimespan();
  const sortedEntries = useMemo(() => [...props.entries].sort((a, b) => sortComponentEntries(sort, a, b)), [props.entries, sort]);
  const additionalProps = useMemo(() => ({
    type: props.type,
    entries: sortedEntries
  }), [props.type, sortedEntries]);
  return /*#__PURE__*/jsx(Table, {
    className: cx(tableCls, props.type),
    thead: /*#__PURE__*/jsx(THead, {
      type: props.type,
      options: sort,
      onSort: onSort
    }),
    contentKey: generateTableKey(filters, sort, appliedTimespan),
    items: sortedEntries,
    Item: TableItem,
    emptyMessage: /*#__PURE__*/jsx(EmptyMessage, {
      hasSearched: !!filters.query
    }),
    additionalProps: additionalProps
  });
}
function THead(props) {
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  return /*#__PURE__*/jsxs(Row, {
    as: "header",
    className: thead,
    sizingCls: rowSizingCls,
    children: [/*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === "componentTitle",
      direction: props.options.direction,
      onSort: () => props.onSort("componentTitle"),
      children: "Titel"
    }), /*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === "productTitle",
      direction: props.options.direction,
      onSort: () => props.onSort("productTitle"),
      children: "L\xE6remiddel"
    }), isMobile && props.type === "finished" && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(ColumnHeading, {
        label: "Dialog"
      }), /*#__PURE__*/jsx(ColumnHeading, {
        label: "Status"
      })]
    }), /*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === "date",
      direction: props.options.direction,
      onSort: () => props.onSort("date"),
      children: "Dato"
    }), props.type === "finished" && /*#__PURE__*/jsxs(Fragment, {
      children: [!isMobile && /*#__PURE__*/jsx(ColumnHeading, {
        children: "Delt"
      }), /*#__PURE__*/jsx(ColumnHeading, {
        children: "Statistik"
      }), !isMobile && /*#__PURE__*/jsx(ColumnHeading, {
        label: "handlinger"
      })]
    })]
  });
}

export { StudentEntriesTable };
//# sourceMappingURL=table.root.js.map
